import request from './request';
import requestWithoutTimeout from './requestWithoutTimeout';

const lotteryService = {
  getAll: (params) => request.get('dashboard/admin/lotteries', { params }),
  export: (params) =>
    requestWithoutTimeout.get('dashboard/admin/lotteries/export', {
      params,
      responseType: 'blob',
    }),
};

export default lotteryService;
